/**
 * Mirrors the backend's shared password-complexity rule
 * (clear-scan/src/common/validators/strong-password.decorator.ts,
 * IsStrongPassword()): at least one uppercase letter, one lowercase
 * letter, and one digit, 6-50 characters.
 *
 * Before this, AddUser/EditUser/Profile's forms only checked
 * `password.length < 6` - weaker than what the backend actually
 * requires now (Admin Medium #15, AUDIT_FIX_LOG.md). A user could pass
 * this page's own validation with e.g. "aaaaaa", submit, and get a
 * confusing server-side rejection that doesn't match what the form just
 * told them was fine. Centralized here rather than duplicated per form,
 * same reasoning as the backend's shared decorator.
 */
const COMPLEXITY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;

export function getPasswordStrengthError(password: string): string | null {
  if (password.length < 6) {
    return 'Password must be at least 6 characters';
  }
  if (password.length > 50) {
    return 'Password must be 50 characters or fewer';
  }
  if (!COMPLEXITY_REGEX.test(password)) {
    return 'Password must contain at least one uppercase letter, one lowercase letter, and one number';
  }
  return null;
}
